import { RemoteListApiKeys } from 'data/usecases/api-keys';
import { makeApiUrlApiKeys } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteListApiKeys = (): RemoteListApiKeys => {
  return new RemoteListApiKeys(makeApiUrlApiKeys(), makeAxiosHttpClient());
};
